import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './i18n/LanguageContext';
import { HomePage } from './components/HomePage';
import { AvisoLegal } from './components/legal/AvisoLegal';
import { PoliticaPrivacidad } from './components/legal/PoliticaPrivacidad';
import { PoliticaCookies } from './components/legal/PoliticaCookies';
export function App() {
  return <LanguageProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <div className="min-h-screen bg-cream selection:bg-sage-light/30 selection:text-forest-dark" data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
            <Route path="/aviso-legal" element={<AvisoLegal data-id="element-7" />} data-id="element-6" />
            <Route path="/politica-privacidad" element={<PoliticaPrivacidad data-id="element-9" />} data-id="element-8" />
            <Route path="/politica-cookies" element={<PoliticaCookies data-id="element-11" />} data-id="element-10" />
          </Routes>
        </div>
      </BrowserRouter>
    </LanguageProvider>;
}